import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SettingsRequisitesVerification = _resolveComponent("SettingsRequisitesVerification")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('fields'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Номер расчетного счета")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.account_number,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requisitesBankRequest.account_number) = $event))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Номер корреспондентского счета")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.correspondent_account,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requisitesBankRequest.correspondent_account) = $event))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Банковский идентификационный код (БИК)")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.bank_identification_code,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requisitesBankRequest.bank_identification_code) = $event))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Полное наименование банка")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.bank_name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requisitesBankRequest.bank_name) = $event))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Идентиф. номер налогоплательщика (ИНН)")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.inn,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requisitesBankRequest.inn) = $event))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, _toDisplayString(_ctx.$t("Код причины постановки на учет (КПП)")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.requisitesBankRequest.registration_reason_code,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requisitesBankRequest.registration_reason_code) = $event))
        }, null, 8, ["modelValue"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('footer'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('footer-group'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('field'))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('field-label'))
          }, _toDisplayString(_ctx.$t("Валюта")), 3),
          _createVNode(_component_SharedSelect, {
            view: "light",
            options: _ctx.displayedCurrencyOptions,
            icon: _ctx.displayedCurrencyIcon,
            value: _ctx.depositWithdrawalStore.currency_id,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.depositWithdrawalStore.currency_id) = $event))
          }, null, 8, ["options", "icon", "value"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('field'))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('field-label'))
          }, _toDisplayString(_ctx.$t("Сумма")), 3),
          _createVNode(_component_UIInput, {
            view: "light",
            type: "number",
            "is-number": true,
            modelValue: _ctx.depositWithdrawalStore.amount,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.depositWithdrawalStore.amount) = $event))
          }, null, 8, ["modelValue"])
        ], 2)
      ], 2),
      (_ctx.isCommissionsShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('message', { amount: true }))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('message-item'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('message-label'))
              }, _toDisplayString(_ctx.$t("Комиссия")), 3),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('message-label'))
              }, _toDisplayString(_ctx.displayedCommission) + " " + _toDisplayString(_ctx.displayedCurrencyName), 3)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('message-item'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('message-label'))
              }, _toDisplayString(_ctx.$t("Вы получите")), 3),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('message-label'))
              }, " ~ " + _toDisplayString(_ctx.displayedAmount) + " " + _toDisplayString(_ctx.displayedCurrencyName), 3)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_UIButton, {
        label: "Создать реквизиты",
        view: "main",
        disabled: _ctx.isDisabled,
        onClick: _ctx.handleCreate
      }, null, 8, ["disabled", "onClick"]),
      _createVNode(_Transition, { name: "opacity" }, {
        default: _withCtx(() => [
          (_ctx.isVerification)
            ? (_openBlock(), _createBlock(_component_SettingsRequisitesVerification, {
                key: 0,
                class: _normalizeClass(_ctx.b('modal')),
                type: "bank-requisite",
                onClose: _ctx.handleVerificationClose
              }, null, 8, ["class", "onClose"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ], 2))
}